module.exports = __webpack_public_path__ + "img/58202b62bc0f068b582ef700056b8e99.svg";